<template>
  <!--通用树形弹窗-->
  <local-dialog
    :title="title"
    :visible="visible"
    :show-close="true"
    :fullscreen="false"
    :append-to-body="appendToBody"
    :width="width"
    :height="height"
    :destroy-on-close="destroyOnClose"
    @close="handleCancel"
  >
    <template slot="content">
      <el-input
        v-if="showSearch && data.length > 0"
        ref="searchInput"
        v-model="filterText"
        clearable
        :placeholder="placeholder || $t('components.pleaseEnter')"
        suffix-icon="el-icon-search"
        class="mb-10"
        size="mini"
        @keyup.native.stop.down="focusFirstChildren"
        @keyup.native.stop.tab="focusFirstChildren"
      />
      <el-tree
        v-if="visible"
        ref="tree"
        class="dialog-tree"
        show-checkbox
        :data="setDisabled(data_)"
        :props="props"
        :check-strictly="checkStrictly"
        :filter-node-method="filterNodeMethod"
        :node-key="nodeKey"
        :default-expand-all="defaultExpandAll"
        :default-expanded-keys="defaultExpandedKeys"
        :render-after-expand="renderAfterExpand"
        :highlight-current="highlightCurrent"
        :expand-on-click-node="expandOnClickNode"
        :check-on-click-node="checkOnClickNode"
        :auto-expand-parent="autoExpandParent"
        :default-checked-keys="defaultCheckedKeys_"
        :current-node-key="currentNodeKey"
        :accordion="accordion"
        :indent="indent"
        :icon-class="iconClass"
        :draggable="draggable"
        @keyup.native.stop.up="handleTreeUp"
        @keyup.native.enter="handleTreeEnter"
        @check="handleCheck"
        @node-click="handleNodeClick"
      />
    </template>
    <template slot="footer">
      <el-button size="mini" plain @click="handleCancel">{{
        $t('btns.cancel')
      }}</el-button>
      <el-button type="primary" size="mini" @click="handleConfirm">{{
        $t('btns.confirmKey')
      }}</el-button>
    </template>
  </local-dialog>
</template>

<script>
import { MessageUtil } from '@cndinfo/cube-web-utils'
import '../../../../lib/styles/components/DialogTree.scss'
import localDialog from '../../Dialog/index.js'
export default {
  name: 'DialogTree',
  components: { localDialog },
  props: {
    // 每个树节点用来作为唯一标识的属性，整棵树应该是唯一的
    nodeKey: {
      type: String,
      default: 'id'
    },
    // 是否在第一次展开某个树节点后才渲染其子节点
    renderAfterExpand: {
      type: Boolean,
      default: true
    },
    // 是否高亮当前选中节点
    highlightCurrent: {
      type: Boolean,
      default: true
    },
    // 是否默认展开所有节点
    defaultExpandAll: {
      type: Boolean,
      default: false
    },
    // 是否在点击节点的时候展开或者收缩节点， 默认值为 true，如果为 false，则只有点箭头图标的时候才会展开或者收缩节点。
    expandOnClickNode: {
      type: Boolean,
      default: true
    },
    // 默认展开的节点的 key 的数组
    defaultExpandedKeys: {
      type: Array,
      default: () => []
    },
    // 是否在点击节点的时候选中节点，默认值为 false，即只有在点击复选框时才会选中节点。
    checkOnClickNode: {
      type: Boolean,
      default: false
    },
    // 展开子节点的时候是否自动展开父节点
    autoExpandParent: {
      type: Boolean,
      default: false
    },
    // 默认勾选的节点的 key 的数组
    defaultCheckedKeys: {
      type: Array,
      default: () => []
    },
    // 当前选中的节点
    currentNodeKey: {
      type: [String, Number],
      default: ''
    },
    // 是否每次只打开一个同级树节点展开
    accordion: {
      type: Boolean,
      default: false
    },
    // 相邻级节点间的水平缩进，单位为像素
    indent: {
      type: Number,
      default: 16
    },
    // 自定义树节点的图标
    iconClass: {
      type: String,
      default: ''
    },
    // 是否开启拖拽节点功能
    draggable: {
      type: Boolean,
      default: false
    },
    // 在显示复选框的情况下，是否严格的遵循父子不互相关联的做法，默认为 false
    checkStrictly: {
      type: Boolean,
      default: false
    },
    // 配置选项，具体看下表
    props: {
      type: Object,
      default: () => {}
    },
    // 数据源
    data: {
      type: Array,
      default: () => []
    },
    // 是否开启双击选中, 单选双击父级不返回、双击子级返回, 多选双击父级返回、双击子级返回
    dblclick: {
      type: Boolean,
      default: true
    },
    // 选择模式, 选单不能选中父级
    selection: {
      type: String,
      default: 'single',
      validator: function(value) {
        return ['single', 'multiple'].indexOf(value) !== -1
      }
    },
    // 是否展示搜索框
    showSearch: {
      type: Boolean,
      default: false
    },
    // 搜索框的值
    searchValue: {
      type: String,
      default: ''
    },
    // 宽度
    width: {
      type: String,
      default: '700px'
    },
    // 标题
    title: {
      type: String,
      default: ''
    },
    // 搜索框提示文字
    placeholder: {
      type: String,
      default: ''
    },
    // 弹窗显隐
    visible: {
      type: Boolean,
      default: false
    },
    // 高度
    height: {
      type: [String, Number],
      default: 400
    },
    // 是否插入body(嵌套时使用)
    appendToBody: {
      type: Boolean,
      default: true
    },
    // 是否销毁弹窗
    destroyOnClose: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      filterText: '',
      curSelNodePartentClassName: null,
      changeByEnter: false, // node是否是因为enter改变
      checkedNodes_before: [], // 选中的值
      checkedNodes_current: [], // 选中的值
      treeClickCount: 0,
      defaultCheckedKeys_: []
    }
  },
  computed: {
    data_() {
      return this.setDisabled(this.arrDeepCopy(this.data)) || []
    }
  },
  watch: {
    visible(nv, ov) {
      if (nv) {
        this.filterText = this.searchValue,
        setTimeout(() => {
          this.$refs.tree && this.$refs.tree.filter(this.filterText)
          this.defaultCheckedKeys_ = this.setdefaultCheckedKeys()
        }, 300)
      } else {
        this.filterText = ''
        this.treeClickCount = 0
        this.defaultCheckedKeys_ = []
      }
    },
    filterText(val) {
      this.$refs.tree && this.$refs.tree.filter(val)
    }
  },
  methods: {
    arrDeepCopy(arr) {
      const sourceCopy = []
      for (const item in arr) {
        sourceCopy[item] =
      typeof arr[item] === 'object' ? this.arrDeepCopy(arr[item]) : arr[item]
      }
      return sourceCopy
    },
    setdefaultCheckedKeys() {
      if (this.selection === 'single') {
        if (this.defaultCheckedKeys.length > 1) {
          return []
        }
        if (this.defaultCheckedKeys.length === 1) {
          const v = this.$refs.tree.getNode(this.defaultCheckedKeys[0])
          return v.childNodes.length > 0 && !this.checkStrictly ? [] : this.defaultCheckedKeys
        }
      }
      return this.defaultCheckedKeys
    },
    // 设置不可选节点
    setDisabled(data) {
      // 单选且无关联, 父级不可选
      data.forEach((item) => {
        item.disabled = item.disabled || false
        if (item.children && item.children.length > 0) {
          item.disabled =
            this.selection === 'single' && !this.checkStrictly
              ? true
              : item.disabled
          item.children = this.setDisabled(item.children)
        }
      })
      return data
    },
    // 节点点击事件 双击/单击
    handleNodeClick(item, node) {
      if (this.dblclick) {
        this.treeClickCount++
        if (this.treeClickCount >= 2) {
          return false
        }
        this.timer = window.setTimeout(() => {
          if (this.treeClickCount === 1) {
            // 单击事件 置0
            this.treeClickCount = 0
            return false
          }
          this.treeClickCount = 0
          // 被禁用
          if (item.disabled) {
            return false
          }
          // 单选, 被选中数据中存在最后一级禁止修改 或者 非最后一级
          const getCheckedNodes = this.$refs.tree.getCheckedNodes() || []
          const disabledArr = getCheckedNodes
            .filter((item) => !item.children)
            .filter((item) => item.disabled)
          if (
            this.selection === 'single' &&
            (disabledArr.length > 0 || item.children)
          ) {
            return false
          }
          this.$refs.tree.setCheckedKeys([item[this.nodeKey]])
          this.handleConfirm()
        }, 300)
      }
    },
    // 点击复选框事件
    handleCheck(item, node) {
      const getCheckedNodes = this.$refs.tree.getCheckedNodes() || []
      if (getCheckedNodes.length === 0) {
        this.$refs.tree.setCheckedKeys([])
        return false
      }
      const disabledArr = getCheckedNodes
        .filter((item) => !item.children)
        .filter((item) => item.disabled)
      if (this.selection === 'single') {
        disabledArr.length > 0 &&
          this.$refs.tree.setCheckedKeys([disabledArr[0][this.nodeKey]])
        disabledArr.length === 0 &&
          this.$refs.tree.setCheckedKeys([item[this.nodeKey]])
      }
      // if (this.changeByEnter) {
      //   this.changeByEnter = false
      // }
      // this.checkedNodes_before = this.checkedNodes_current
      // this.checkedNodes_current = this.$refs.tree.getCheckedNodes()
      // this.judgeAddOrDel(item)
    },
    // 过滤
    filterNodeMethod(value, data) {
      if (!value) return true
      return (
        data[this.props.label] && data[this.props.label].indexOf(value) !== -1
      )
    },
    // 确定选择
    handleConfirm() {
      const checkedNodes = this.$refs.tree.getCheckedNodes()
      if (checkedNodes.length === 0) {
        MessageUtil.warning(this.$t('grid.tips.selectAtLeastOne'))
        return false
      }
      const lastNodes = checkedNodes.filter((item) => {
        return (
          this.checkStrictly || !item.children || item.children.length === 0
        )
      })
      this.handleSelect(lastNodes)
    },
    // 关闭/取消
    handleCancel() {
      this.$emit('update:visible', false)
      this.$emit('onCancel')
    },
    // 确定
    handleSelect(value = []) {
      this.$emit('update:visible', false)
      this.$emit('onSelect', value)
    },
    // 方向上键
    handleTreeUp(e) {
      const parentClassName = e.srcElement.parentElement.className
      if (
        this.curSelNodePartentClassName === 'el-tree' &&
        parentClassName === 'el-tree'
      ) {
        this.$refs.searchInput.focus()
      }
      this.curSelNodePartentClassName = parentClassName
    },
    // enter键
    handleTreeEnter() {
      // 1：屏蔽回车选中事件(选中后给复原)
      this.changeByEnter = true
      this.checkedNodes_current = this.checkedNodes_before
      const curKeys = []
      this.checkedNodes_before.forEach((item) => {
        curKeys.push(item.id)
      })
      this.$refs.tree.setCheckedKeys(curKeys)

      // 2：延时500毫秒 然后关闭弹窗
      setTimeout(() => {
        this.handleConfirm()
      }, 500)
    },
    // 聚焦在第一个选项(未解决)
    focusFirstChildren() {
      if (
        this.$refs.tree &&
        this.$refs.tree.$children[0] &&
        this.$refs.tree.$children[0].$el
      ) {
        this.$nextTick(() => {
          this.$refs.tree.$children[0].$el.children[0].focus()
        })
      }
    }
  }
}
</script>
